module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(" 个人信息")]), _vm._v(" "), _c('el-form', [_c('div', {
    staticClass: "container"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.profile.name,
      "placeholder": "请填写姓名"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'profile',
          b: 'name'
        })
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.profile.citry,
      "placeholder": "请填写所在城市"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'profile',
          b: 'citry'
        })
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生年月"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.profile.birth,
      "placeholder": "请填写出生年月日"
    },
    on: {
      "change": function($event) {
        _vm.changeEditor({
          $event: $event,
          a: 'profile',
          b: 'birth'
        })
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7057b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/ProfileEditor.vue
// module id = 195
// module chunks = 1